import React from 'react'
import myimg from "../../../assets/images/group.png"

const backPicutre = () => {
  return (
    <>
    <div className="picture-title  text-center">Back Pictures</div>
    <div className="front-picture-licence">
    
    <img src={myimg} className="myimg" alt="front-picutre" />
  </div>
  </>
  )
}

export default backPicutre